import {FC, useMemo} from 'react'
import {Modal} from 'react-bootstrap'
import {useLocation} from 'react-router-dom'
import {useSelectTreatmentModal} from '../core/_ModalProvider'

type Props = {
  onReserve: () => void
}

const BookingSuccessModal: FC<Props> = ({onReserve}) => {
  const {showSuccess, closeSuccessModal} = useSelectTreatmentModal()

  const location = useLocation()
  const isBooking = useMemo(() => {
    return location.pathname?.startsWith('/booking')
  }, [location.pathname])

  if (isBooking && showSuccess) {
    return (
      <div className='modal_wrapper active'>
        <div className='shadow close_btn'></div>

        <div className='modal overflow-visible'>
          <div className='modal_item s_modal active'>
            <div className='close close_btn' onClick={() => closeSuccessModal()}>
              <i className='b bi-x fs-3' />
            </div>
            <div className='modal_body'>
              <div className='s_icon'>
                <i className='b bi-check2 fs-1' />
              </div>
              <div className='s_text'>
                <h2>SUCCESS</h2>
                <p>Reservasi berhasil! Kami akan menghubungi Anda untuk konfirmasi.</p>
              </div>
            </div>
            <div className='s_button'>
              <button className='success_btn' type='button' onClick={() => closeSuccessModal()}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <Modal className='modal fade' onHide={closeSuccessModal} show={showSuccess}>
      <div className='modal-content'>
        <div className='modal-body'>
          <div className='row text-center'>
            <div className='col-12'>
              <div className='d-flex justify-content-center p-7'>
                <i className='bi bi-check-circle-fill text-success' style={{fontSize: 96}}></i>
              </div>
            </div>
            <div className='col-12'>
              <h3>Reservasi Order Berhasil Terkirim</h3>
            </div>
            <div className='col-12'>
              <p>
                Terima kasih sudah melakukan Reservasi secara online, kami akan melakukan konfirmasi
                kembali kepada anda melalui Telepon.
              </p>
            </div>
            <div className='col-12'>
              <b>Untuk melakukan reservasi lagi, silahkan klik tombol dibawah ini</b>
            </div>
            <div className='col-12'>
              <button
                className='btn btn-primary btn-sm mt-4 w-75'
                type='button'
                onClick={onReserve}
              >
                Reservasi
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export {BookingSuccessModal}
